import { http } from "./config";

class LoginService {
  login(data) {
    return http.post("/v1/login", data);
  }
}

export default new LoginService();
